import React, { useRef, useState, useEffect } from 'react'
import { withRouter } from 'react-router-dom'

import { useDispatch, useSelector } from 'react-redux'
import { logout } from '../redux/actions/auth'
import { setFromLink } from '../redux/actions/select'
import queryString from 'query-string'

import {
  Grid, Paper, Typography, Button, AppBar, Toolbar,
  BottomNavigation, BottomNavigationAction, Avatar,
  IconButton, CardMedia,
  Card, CardContent, Tabs, Tab, Drawer
} from '@material-ui/core'
import AnnouncementIcon from '@material-ui/icons/Announcement'

import { makeStyles, withStyles } from '@material-ui/core/styles'
import { NavigateNext, NavigateBefore, MoreVert, Info as InfoIcon } from '@material-ui/icons'

import {
  getComments, getViolationTerms, getViolations,
  getHistory, postHistory, getRoleSupervisors, getHistoryActions
} from '../redux/actions'

import { Toast, getSeverityClass } from '../utils'
import { statusTypes } from '../utils/variables'
import { QuarantineSubBanner } from '../components/ui/tools'
import { TabPanel } from '../components/ui/tools/MobileViewTabs'
import { MobileDetails } from '../components/ui/tools/MobileSingleDetails'
// import { NotificationToast } from '../components/ui/tools'

import log from 'loglevel'

const logo = require('../assets/images/logo5.png')
const tempImage = require('../assets/images/quarantine_1.png')

const useStyles = makeStyles((theme) => ({
  paperRoot: {
    backgroundColor: '#3134384a'
  },
  whiteText: {
    color: '#FFFFFF'
  },
  paperContainer: {
    height: '100vh',
    width: '100vw'
  },
  blueBtn: {
    backgroundColor: '#3984f7',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#0651C4'
    },
    '&:disabled': {
      backgroundColor: 'rgba(57, 132, 247, 0.50)'
    }
  },
  darkNav: {
    backgroundColor: '#313438',
    opacity: 1,
    zIndex: 1000
  },
  stickToBottom: {
    width: '100%',
    position: 'fixed',
    bottom: 0
  },
  learnsafeLogo: {
    width: '100%',
    height: 'auto',
    margin: 'auto 0',
    backgroundSize: 'contain'
  },
  logoContainer: {
    marginTop: 'auto',
    marginBottom: 'auto',
    paddingTop: 0,
    paddingBottom: 0
  },
  logoutBtn: {
    backgroundColor: '#313438'
  },
  logoutText: {
    fontWeight: 'bold',
    color: '#313438'
  },
  severityTag: {
    backgroundColor: 'red',
    height: '1.5rem',
    width: '2rem',
    fontSize: '1rem'
  },
  listRoot: {
    width: '100%',
    position: 'relative',
    overflowX: 'auto',
    maxHeight: 200
  },
  commentAvatar: {
    width: theme.spacing(5),
    height: theme.spacing(5),
    backgroundColor: '#3984f7'
  },
  tabsRoot: {
    '& .Mui-selected': {
      outline: 'none'
    }
  },
  tabsIndicator: {
    backgroundColor: '#3984f7'
  },
  loadingColor: {
    color: '#97b557'
  },
  mild: {
    background: '#5291fc'
  },
  okay: {
    background: '#4e179a',
    color: '#ffffff'
  },
  notGreat: {
    background: '#e7840f',
    color: '#ffffff'
  },
  warn: {
    background: '#f5d818',
    color: '#414342'
  },
  bad: {
    background: '#d31111',
    color: '#ffffff'
  },
  btnPagination: {
    color: '#3984f7',
    fontSize: '18px'
  },
  navIcon: {
    fontSize: 'xx-large'
  }
}))

const StyledNav = withStyles({
  root: {
    color: '#3984f7',
    '&$selected': {
      color: '#3984f7',
      outline: 'none'
    },
    '&:disabled': {
      color: 'rgba(0, 0, 0, 0.54)'
    }
  },
  selected: {}
})(BottomNavigationAction)

const MobileSingle = (props) => {
  const { fromLink } = props
  const classes = useStyles()
  const anchorRef = useRef(null)
  const dispatch = useDispatch()
  const parsedProps = queryString.parse(props.location.search)

  const currentSupervisor = useSelector(state => state.auth.supervisorID)
  const Captures = useSelector(state => state.violations.violations.captures)
  const Filter = useSelector(state => state.selection.Filter)
  const currentCapture = parseInt(parsedProps.capture, 10)
  const userRoleSupervisors = useSelector(state => state.userListings.userRoleSupervisors)
  const violationTerms = useSelector(state => state.violations.violationTerms)
  const comments = useSelector(state => state.violations.comments)
  const history = useSelector(state => state.violations.history)
  const actions = useSelector(state => state.violations.actions)
  const hasHistory = useSelector(state => state.violations.hasHistory)

  const [menuOpen, setMenuOpen] = useState({
    top: false,
    left: false,
    bottom: false,
    right: false
  })
  const [tabValue, setTabValue] = useState(0)
  const [allSupervisors, setAllSupervisors] = useState([])
  const [violationComments, setViolationComments] = useState([])
  const [violationHistory, setViolationHistory] = useState([])
  const [violationAdditionalTerms, setViolationAdditionalTerms] = useState([])

  const [captureInfo, setCaptureInfo] = useState(null)
  const [navBtn, setNavBtn] = useState(null)

  const statusColors = {
    [statusTypes.UNVIEWED]: '#CB9BFF',
    [statusTypes.PROBLEM]: '#FFA593',
    [statusTypes.NOT_A_PROBLEM]: '#96E1A8',
    [statusTypes.HOLD]: '#ffff91',
    [statusTypes.RESOLVED]: '#A6FFFF'
  }

  useEffect(() => {
    dispatch(getViolations(Filter))
      .catch((err) => {
        log.error(err)
        Toast.fire({
          icon: 'error',
          title: 'Error fetching initial capture list.'
        })
      })
    dispatch(getRoleSupervisors())
    dispatch(getHistoryActions())
  }, [dispatch, Filter])

  useEffect(() => {
    const capture = Captures[currentCapture - 1]
    if (capture) {
      const tempID = capture.violationID
      setCaptureInfo(capture)
      dispatch(getComments([tempID]))
      dispatch(getHistory([tempID]))
      dispatch(getViolationTerms(tempID))
    }
  }, [Captures, currentCapture, dispatch])

  useEffect(() => {
    if (userRoleSupervisors.length !== 0) {
      const mappedSupervisors = []
      userRoleSupervisors.forEach((supervisor) => {
        mappedSupervisors.push(...supervisor.roleSupervisors)
      })

      setAllSupervisors(mappedSupervisors)
    }
  }, [userRoleSupervisors, currentSupervisor])

  useEffect(() => {
    if (comments && allSupervisors.length !== 0) {
      const mappedComments = comments.map((comment) => {
        const commentSupervisor = allSupervisors.find((supervisor) => {
          return comment.supervisorID === supervisor.supervisorID
        })

        return {
          ...comment,
          ...commentSupervisor
        }
      })
      setViolationComments(mappedComments)
    }
  }, [comments, allSupervisors])

  useEffect(() => {
    if (history !== undefined && allSupervisors.length !== 0 && actions.length !== 0) {
      const mappedHistory = history.map((historyItem) => {
        const historySupervisor = allSupervisors.find((supervisor) => {
          return historyItem.supervisorID === supervisor.supervisorID
        })

        const historyAction = actions.find((action) => {
          return historyItem.actionID === action.actionID
        })

        if (historyItem.targetID !== null) {
          const targetSupervisor = allSupervisors.find((supervisor) => {
            return supervisor.supervisorID === historyItem.targetID
          })

          const { firstName, lastName } = targetSupervisor

          const actualHistoryAction = `${historyAction.details.toLowerCase()} ${firstName} ${lastName}`

          return {
            historyAction: actualHistoryAction,
            ...historyItem,
            ...historySupervisor,
            ...historyAction
          }
        } else {
          const actualHistoryAction = `${historyAction.details.toLowerCase()}`
          return {
            historyAction: actualHistoryAction,
            ...historyItem,
            ...historySupervisor,
            ...historyAction
          }
        }
      })

      setViolationHistory(mappedHistory)
    }
  }, [history, actions, allSupervisors])

  useEffect(() => {
    if (hasHistory && history != null && actions.length !== 0 && currentSupervisor !== '' && captureInfo !== null) {
      const addHistoryUser = (action) => {
        dispatch(postHistory([captureInfo.violationID], action, 'VIEWED', null, fireAddSuccess, fireAddFailure))
      }

      const fireAddSuccess = () => {
        dispatch(getHistory([captureInfo.violationID]))
      }

      const fireAddFailure = () => { }

      const viewedAction = actions.find((action) => action.details === 'VIEWED')
      const viewedHistory = history.filter((historyItem) => historyItem.actionID === viewedAction.actionID)

      if (viewedHistory) {
        const hasViewed = viewedHistory.find((historyItem) => historyItem.supervisorID === currentSupervisor)
        if (hasViewed === undefined) {
          addHistoryUser(viewedAction.actionID)
        }
      }
    }
  }, [hasHistory, history, actions, currentSupervisor, captureInfo, dispatch])

  useEffect(() => {
    if (violationTerms) {
      setViolationAdditionalTerms(violationTerms)
    }
  }, [violationTerms])

  const handleMenuOpen = (anchor, open) => {
    setMenuOpen({ ...menuOpen, [anchor]: open })
  }

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue)
  }
  const handleLogOut = (e) => {
    e.stopPropagation()
    e.preventDefault()
    if (fromLink) {
      dispatch(setFromLink(false))
    }
    dispatch(logout())
  }

  const getAvatarBackground = (severity) => {
    if (severity !== '-') {
      switch (getSeverityClass(severity)) {
        case 'mild': return classes.mild
        case 'bad': return classes.bad
        case 'okay': return classes.okay
        case 'notGreat': return classes.notGreat
        case 'warn': return classes.warn
        default: return null
      }
    } else {
      return '#FFFFFF'
    }
  }

  const handleNavigation = (event, newValue) => {
    setNavBtn(newValue)
    if (newValue === 2) {
      if (currentCapture >= Captures.length) {
      } else {
        props.history.push({
          pathname: '/captures',
          search: `?view=single&capture=${currentCapture + 1}`
        })
      }
    } else if (newValue === 0) {
      if (currentCapture - 1 <= 0) {
      } else {
        props.history.push({
          pathname: '/captures',
          search: `?view=single&capture=${currentCapture - 1}`
        })
      }
    }
  }

  const getCardMediaImage = (capture) => {
    const { signedUrl, quarantined, redacted } = capture
    const imageSrc = quarantined && !redacted ? tempImage : signedUrl
    return (
      <>
        <CardMedia
          component='img'
          image={imageSrc}
        />
        {quarantined && <QuarantineSubBanner redacted={redacted} fontSize={14} />}
      </>
    )
  }

  // **** Temporary Condition for testing, replace 'fromLink' below to test without using a link ***
  // const testing = true

  return (
    <>
      {/* Change 'fromLink' to 'testing' when testing without a link */}
      {fromLink
        ? (
          // What the user sees when navigating from a Link
          <>
            {/* Top Navigation */}
            <AppBar className={classes.darkNav}>
              <Toolbar>
                <Grid item container direction='row'>
                  <Grid item container justify='flex-start' xs={4} md={2} className={classes.logoContainer}>
                    <Avatar src={logo} alt='Logo' className={classes.learnsafeLogo} variant='rounded' />
                  </Grid>
                  <Grid item container justify='flex-end' xs={8} md={10}>
                    {/* More Options Button */}
                    <IconButton ref={anchorRef} onClick={() => handleMenuOpen('top', true)}>
                      <MoreVert style={{ color: '#FFFFFF' }} />
                    </IconButton>
                    {/* Limited Functionality Message and Logout Button */}
                    <Drawer anchor='top' open={menuOpen.top} onClose={() => handleMenuOpen('top', false)}>
                      <Grid container direction='row' justify='center' alignContent='center'>
                        <Grid container direction='column' alignContent='center'>
                          <Grid item container direction='row' justify='center' className='mt-4'>
                            <AnnouncementIcon style={{ color: 'rgb(180 220 95)', fontSize: 'xxx-large' }} />
                          </Grid>
                        </Grid>
                        <Grid item container direction='column' alignContent='center' className='mb-3 mx-5 mt-2'>
                          <Typography variant='h6' style={{ fontWeight: 'bold', textAlign: 'center', color: '#3984f7' }} gutterBottom>Heads Up!</Typography>
                          <Typography variant='body1' style={{ fontWeight: 'bold', textAlign: 'center', color: '#666666' }} gutterBottom>More Good Stuff is Coming to Mobile</Typography>
                          <Typography variant='body2' style={{ textAlign: 'center', color: '#666666' }} gutterBottom>
                            While we are working hard to develop more features for LearnSafe’s Mobile View please log in with a desktop device to access full functionality. For now, the Mobile View will allow you to access any data that has been sent to you via a Shared Link (Email Alerts and Shared Captures).
                          </Typography>
                          <Typography variant='body1' style={{ fontWeight: 'bold', textAlign: 'center', color: '#3984f7' }} gutterBottom>Keep checking back!</Typography>

                        </Grid>
                        <Grid item container direction='row' justify='center' className='mb-3'>
                          <Button onClick={() => handleMenuOpen('top', false)} className='mr-2'>Cancel</Button>
                          <Button variant='contained' onClick={handleLogOut} className={classes.blueBtn}>Logout</Button>
                        </Grid>
                      </Grid>
                    </Drawer>
                  </Grid>
                </Grid>
              </Toolbar>
            </AppBar>

            {/* Main View Area */}
            <Grid
              container
              direction='row'
              justify='center'
              alignItems='flex-start'
              key='no-return-message-grid'
            >
              <Card
                style={{
                  margin: '1em',
                  marginTop: '5em',
                  borderLeft: `.5em solid ${statusColors[captureInfo?.statusFlag] || '#efefef'}`
                }}
              >
                {/* Image only loads once the information has been obtained */}
                {captureInfo && getCardMediaImage(captureInfo)}

                {/* Details */}
                <CardContent>
                  {/* Detail Header */}
                  <Grid container direction='column' className='mt-2'>
                    <Grid item container direction='row'>
                      <Grid item xs={9}>
                        <Typography variant='h6' className='font-weight-bold text-primary' style={{ marginLeft: '.5rem' }}><InfoIcon fontSize='small' style={{ marginRight: '.5rem' }} />DETAILS</Typography>
                      </Grid>
                      <Grid item container justify='flex-end' xs={3}>
                        {captureInfo !== null &&
                          <Avatar variant='rounded' classes={{ root: classes.severityTag }} className={getAvatarBackground(captureInfo.severity)}>{captureInfo.severity}</Avatar>}
                      </Grid>
                    </Grid>

                    {/* Details List, imported */}
                    <MobileDetails
                      classes={classes}
                      capture={Captures[currentCapture - 1]}
                      additionalTerms={violationAdditionalTerms}
                    />
                  </Grid>

                  {/* Tabs Start */}
                  <Grid container className='mt-3'>
                    <Paper className='w-100'>
                      <Tabs
                        value={tabValue}
                        onChange={handleTabChange}
                        variant='fullWidth'
                        classes={{ indicator: classes.tabsIndicator, root: classes.tabsRoot }}
                      >
                        <Tab label='Comments' />
                        <Tab label='History' />
                      </Tabs>
                      {/* Information rendered conditionally in TabPanel import */}
                      <TabPanel value={tabValue} index={0} comments={violationComments} classes={classes}>Comment Accordion</TabPanel>
                      <TabPanel value={tabValue} index={1} classes={classes} history={violationHistory}>History Accordion</TabPanel>
                    </Paper>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>

            {/* Used to keep content above bottomNavigation */}
            <div style={{ height: '56px' }} />

            {/* Bottom Navigation */}
            <BottomNavigation
              value={navBtn}
              className={`${classes.stickToBottom} pb-1`}
              onChange={handleNavigation}
              showLabels
            >
              {/* Back Button */}
              <StyledNav
                value={0}
                disabled={currentCapture - 1 <= 0}
                label='Back'
                icon={
                  <NavigateBefore classes={{ root: classes.navIcon }} />
                }
              />
              {/* Pagination Numbers */}
              <BottomNavigationAction
                value={1}
                disabled
                classes={{ label: classes.btnPagination }}
                label={`${currentCapture} of ${Captures.length}`}
              />
              {/* NextButton */}
              <StyledNav
                value={2}
                disabled={currentCapture >= Captures.length}
                label='Next'
                icon={
                  <NavigateNext style={{ fontSize: 'xx-large' }} />
                }
              />
            </BottomNavigation>
          </>
        )
        : (
          // What the user sees when navigating WITHOUT a link
          <Grid
            container
            className={classes.paperContainer}
            direction='row'
            justify='center'
            alignItems='center'
            key='no-return-message-grid'
          >
            <Grid container item direction='column' xs={10}>
              <Grid container item direction='row' justify='center'>
                <Grid item xs={10} style={{ marginBottom: '1em' }}>
                  <h1>
                    <img src={require('../assets/images/logo2.png')} className='logo' alt='LearnSafe Cloud' />
                  </h1>
                </Grid>
              </Grid>
              <Paper
                classes={{ root: classes.paperRoot }}
                elevation={3}
              >
                <Grid container direction='column'>
                  <Grid item container direction='row' justify='center' className='mt-3'>
                    <AnnouncementIcon style={{ color: '#FFFFFF', fontSize: 'xx-large' }} />
                  </Grid>
                </Grid>
                <Grid item container direction='column' justify='center' alignItems='center'>
                  <Grid item>
                    <Typography variant='h6' style={{ fontWeight: 'bold', color: '#FFFFFF' }}>Woops!</Typography>
                  </Grid>
                  <Grid item container direction='column' justify='center' alignItems='center'>
                    <Typography variant='body1' gutterBottom style={{ color: '#FFFFFF', fontWeight: 'bold', textAlign: 'center' }}> Looks like you're using a mobile device.</Typography>
                    <Typography variant='body2' gutterBottom style={{ color: '#FFFFFF', textAlign: 'center' }}>We are making progress... but for now, you'll need to login from a desktop or laptop for full functionality.</Typography>
                    <Typography variant='body2' gutterBottom style={{ color: '#FFFFFF', textAlign: 'center' }}>Mobile devices can work when accessed by a shared link.</Typography>
                  </Grid>
                  <Grid item container justify='center' className='my-3'>
                    <Button variant='contained' className={classes.blueBtn} onClick={handleLogOut}>Log Out</Button>
                  </Grid>
                </Grid>
              </Paper>
            </Grid>
          </Grid>
        )}
    </>
  )
}

export default withRouter(MobileSingle)
